import { reactive, computed, toRefs } from '@vue/composition-api';
import store from '@/store/';

/**
 * [hook]
 * Torna o state de um determinado modulo reactivo.
 *
 * @param {Object} store
 * @param {String} module
 * @param {String} state
 * @returns {Function} retorna o state reactivo do modulo passado.
 * @since 1.0.0
 * @category Hook
 * @author Tiago Martinho
 *
 */
const computedState = ( module, state ) => computed( () => store.state[module][state] );

/**
 * [hook]
 * Obtém o state de um determinado modulo.
 *
 * @param {Object}
 * @returns {Function} retorna o state do modulo passado.
 * @since 1.0.0
 * @category Hook
 * @author Tiago Martinho
 *
 */
const mapState = ({ module, key }) => {
    const state = computedState( module, key );

    return state;
};

/**
 * [hook]
 * Obtém as acções da store.
 *
 * @returns {Function} retorna acções
 * @since 1.0.0
 * @category Hook
 * @author Tiago Martinho
 *
 */
const useActions = () => ({ actions: store.dispatch });

/**
 * [hook]
 * Obtém os getters & acções da store.
 *
 * @returns {Object}
 * @since 1.0.0
 * @category Hook
 * @author Tiago Martinho
 *
 */
const useStore = () => ({ getters: store.getters, actions: store.dispatch });

/**
 * [hook]
 * Obtém o state do payload.
 *
 * @returns {Object}
 * @since 1.0.0
 * @category Hook
 * @author Tiago Martinho
 *
 */
const storePayload = () => {
    const model = reactive({
        reset: mapState({ module: 'storePayload', key: 'reset' }),
        errors: mapState({ module: 'storePayload', key: 'errors' }),
        payload: mapState({ module: 'storePayload', key: 'payload' })
    });

    return { ...toRefs( model ) };
};

export {
    mapState,
    useActions,
    useStore,
    storePayload
};